<!-- 
程式：CarReserveModal.vue
功能：車火險預約單主頁面
作者：i9400520
完成：2019-01-07
-->
<template>
  <div>
    <div class="container-fluid" style="overflow: hidden;">
      <div
        class="mb-3"
        :class="{'section-loading': infoLoading}"
        style="overflow: hidden;max-height: 140px;"
      >
        <div class="float-left w-75 pr-3">
          <h4 class="mb-line text-green mt-0 mb-0">
            {{ categoryInfo.subcategory }}-{{ categoryInfo.category_name }}
            <i
              v-if="categoryInfo.upload_file =''"
              class="icon-attach text-orange ml-2"
            ></i>
            <span
              style="font-size: medium;color: black;"
            >{{ categoryInfo.upload_file | removeExten }}</span>
          </h4>
          <div class="mb-line" style>
            <span
              class="font-weight-bold mr-2"
            >{{ categoryInfo.upload_date | dateFormat }} ~ {{ categoryInfo.end_date | dateFormat }}</span>
          </div>
          <div class>
            <span class="font-weight-bold mr-2">{{ categoryInfo.description }}</span>
          </div>
        </div>
        <div class="float-left w-25">
          <div class="mb-line">
            <span class="font-weight-bold mr-2">維護單位</span>
            <span>{{ categoryInfo.dev_name }}</span>
          </div>
          <div class>
            <span class="font-weight-bold mr-2">聯絡電話</span>
            <span>{{ categoryInfo.contact }}</span>
          </div>
          <div class="mb-line">
            <span class="font-weight-bold mr-2">聯絡分機</span>
            <span>{{ categoryInfo.contact_tel }}</span>
          </div>
          <div :class="{'section-loading': isLoading_btn}">
            <a class="btn btn-default m-0" @click="satisfactionModal" v-if="isBtnEnble">滿意度調查</a>
            <a class="btn btn-default m-0" @click="alreadyDone" disabled="disabled" v-else>滿意度調查</a>
            &nbsp;&nbsp;
            <button
            type="button"
            style="height:43px;"
            @click="backToIndex"
            class="position-absolute btn btn-default m-0"
            v-html="'<span style=\'font-size:1rem\'>回上一頁<span>'"
          ></button> 
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="container-fluid" :class="{'section-loading': isLoading}">
      <div class="row">
        <car-fire-insurance-reserve-data-table
          :height="data_table_height"
          @update="updateSelection"
          @comment-modal="commentModal"
          @jump-to-customer="jumpToCustomer"
          @scheduled-access="ScheduledAccess"
          @openCarReserveModal="openCarReserveModal"
          @openFireReserveModal="openFireReserveModal"
          :table-data="tableData"
        />
      </div>
    </div>

    <section class="container-fluid fixed-bottom">
      <div class="row">
        <div class="col-12"></div>
        <div class="col-9 col-sm-8 col-md-8">
          <div class="list inline">
          </div>
        </div>
        <div class="col-3 col-sm-4 col-md-4 text-right">
          <button
            class="btn btn-primary"
            @click="panelOpen('groupModalOpen')"
            :disabled="!selection.length"
          >加入群組</button>
          <button
            class="btn btn-primary mr-0"
            @click="panelOpen('printModalOpen')"
            :disabled="!selection.length"
          >列印名條</button>
        </div>
      </div>
    </section>

    <!-- 車險明細 -->
    <car-reserve-modal
      :open="carReserveModalOpen"
      :loading="carReserveModalLoading"
      :detailData="carReserveDetailData"
      @close="closeCarReserveModal"
    />

    <!-- 火險明細 -->
    <fire-reserve-modal
      :open="fireReserveModalOpen"
      :loading="fireReserveModalLoading"
      :detailData="fireReserveDetailData"
      @close="closeFireReserveModal"
    />

    <!-- 列印名條 -->
    <print-modal :open="printModalOpen" :custs="selection" @close="panelClose('printModalOpen')"/>

    <!-- 加入群組 -->
    <group-modal
      :open="groupModalOpen"
      :custs="selection"
      @submit="submitGroup"
      @close="panelClose('groupModalOpen')"
    />

    <comment-modal
      :open="commentModalOpen"
      :comment="comment"
      @close="panelClose('commentModalOpen')"
    />

    <satisfaction-modal
      :open="satisfactionModalOpen"
      @report="report"
      @close="panelClose('satisfactionModalOpen')"
    />

    <scheduled-access
      :open="ScheduledAccessModalOpen"
      :record="currentRecord"
      :cat-info="categoryInfo"
      @close="panelClose('ScheduledAccessModalOpen')"
      @submit="submitScheduledAccess"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import PrintModal from "@/desktop/components/PrintModal";
import GroupModal from "@/desktop/components/GroupModal";
import CarFireInsuranceReserveDataTable from "../DataTable/CarFireInsuranceReserveDataTable";
import CommentModal from "../CommentModal";
import SatisfactionModal from "../SatisfactionModal";
import {
  getCarFireInsuranceReserve,
  getCarInsuranceReserve,
  getFireInsuranceReserve,
  getCategoryDetail,
  isSatisfactionSurveyFinish
} from "@/service";
import ScheduledAccess from "../ScheduledAccess";
import moment from "moment";
import CarReserveModal from "@/desktop/components/CarReserveModal";
import FireReserveModal from "@/desktop/components/FireReserveModal";

export default {
  name: "CarFireInsuranceReserve",
  mixins: [commonMixin],
  components: {
    CarFireInsuranceReserveDataTable,
    CommentModal,
    SatisfactionModal,
    PrintModal,
    GroupModal,
    ScheduledAccess,
    CarReserveModal,
    FireReserveModal
  },
  props: {
    status: String
  },
  computed: {},
  data() {
    //data block layout
    return {
      currentPage: 0,
      isLoading: false,
      isLoading_btn: false,
      isBtnEnble: true,
      infoLoading: false,
      printModalOpen: false,
      groupModalOpen: false,
      tableData: [],
      selection: [],
      commentModalOpen: false,
      satisfactionModalOpen: false,
      comment: "",
      data_table_height: 0,
      ScheduledAccessModalOpen: false,
      categoryInfo: {},
      currentRecord: {},
      edit_access_index: 0,
      edit_access_name: "",
      info: {},
      carReserveDetailData: [],
      carReserveModalOpen: false,
      carReserveModalLoading: false,
      fireReserveDetailData: [],
      fireReserveModalOpen: false,
      fireReserveModalLoading: false
    };
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    updateSelection(val) {
      this.selection = val;
    },
    commentModal(comment) {
      this.comment = comment;
      this.panelOpen("commentModalOpen");
    },
    satisfactionModal() {
      this.panelOpen("satisfactionModalOpen");
    },
    report() {
      this.$toast.info({ title: "滿意度調查 已回報" });
      this.isBtnEnble = false;
      this.panelClose("satisfactionModalOpen");
    },
    jumpToCustomer(index) {
      // 導頁到客戶資料
      this.updateCustID(index);
      localStorage.CustID = index;
      this.$router.push({ path: `/detail/CustID/tab/1` });
    },
    backToIndex() {
      // 回上一頁
      this.$emit("change-status", "STATUS_INTEGRATED_MARKETING_LIST");
    },
    submitGroup(group) {
      // 加入群組導頁至 群組列表
      this.panelClose("groupModalOpen");
      this.$router.push({
        path: `/group/1`,
        query: { grp_id: group.grp_id, grp_name: group.grp_name }
      });
    },
    checkIsSatisfactionSurveyFinish() {
      // 檢查是否已回報過滿意度調查
      this.isLoading_btn = true;
      isSatisfactionSurveyFinish(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        if (result.header && result.header.status === "200") {
          this.isBtnEnble = result.body.isfinish === "0";
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "查詢滿意度調查失敗,請重新操作" });
          }
        }
        this.isLoading_btn = false;
      });
    },
    alreadyDone() {
      this.$toast.info({ title: "您已回報過滿意度調查,無法重複操作" });
    },
    initCarFire() {
      // 資料初始化
      this.checkIsSatisfactionSurveyFinish();
      // 取得列表資料
      this.isLoading = true;
      getCarFireInsuranceReserve(
            this.$store.state.userInfo.id,
            this.$store.state.userInfo.id
          ).then(result => {
            this.isLoading = false;
            if (result.header && result.header.status === "200") {
              this.tableData = result.body.result.map(item => {
                let ageText = this.paddingLeft(item.age == "0" ? "0" : item.age ? item.age : "00000", 4, "0");
                let birthdayText = item.customer_birthday || "0000-01-01";
                return {
                  customer_id: item.customer_id || "",
                  customer_name: item.customer_name || "",
                  customer_birthday: item.customer_birthday || "",
                  age: item.age == undefined ? "" : item.age.toString(), //客戶年齡
                  birthdaySort : ageText + "_" + birthdayText, //生日排序用
                  customer_day_phone:
                    item.customer_day_phone === "()#"
                      ? ""
                      : item.customer_day_phone || "",
                  customer_cellular_phone: item.customer_cellular_phone || "",
                  customer_sex: item.customer_sex || "",
                  edate: item.edate || "",
                  is_car: item.is_car || "",
                  is_fire: item.is_fire || "",
                  caseno: item.caseno,
                  seqno: item.seqno,
                  is_exist: item.is_exist || false //判斷是否有客戶資料
                };
              });
              this.registerHanlink(); // for hard word
            }
          });
      // 取得專區資訊
      this.getTitleInfo();
    },
    getTitleInfo() {
      // 取得專區資訊
      this.infoLoading = true;
      getCategoryDetail(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        this.infoLoading = false;
        if (result.header && result.header.status === "200") {
          this.categoryInfo = result.body[0];
        }
      });
    },
    ScheduledAccess(index) {
      this.edit_access_index = index;
      this.currentRecord = this.tableData[index];
      this.panelOpen("ScheduledAccessModalOpen");
    },
    submitScheduledAccess(record, selectedTags) {
      this.panelClose("ScheduledAccessModalOpen");
      // 資料初始化
      this.initHighAssets();
    },
    openCarReserveModal(item) {
      this.carReserveModalOpen = true;
      this.carReserveModalLoading = true;
      getCarInsuranceReserve(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.id,
        item.customer_id,
        item.caseno,
        item.seqno
      ).then(result => {
        this.carReserveModalLoading = false;
        if (result.header && result.header.status === "200") {
          this.carReserveDetailData = result.body.result;
        }
      });
    },
    closeCarReserveModal() {
      this.carReserveModalOpen = false;
    },
    openFireReserveModal(item) {
      this.fireReserveModalOpen = true;
      this.fireReserveModalLoading = true;
      getFireInsuranceReserve(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.id,
        item.customer_id,
        item.caseno
      ).then(result => {
        this.fireReserveModalLoading = false;
        if (result.header && result.header.status === "200") {
          this.fireReserveDetailData = result.body.result;
        }
      });
    },
    closeFireReserveModal() {
      this.fireReserveModalOpen = false;
    }
  },
  mounted() {
    // 資料初始化
    this.initCarFire();

    this.data_table_height =
      parseInt($(window).height()) - $("tbody").offset().top - 80;
    let self = this;
    $(window).bind("orientationchange", function(event) {
      self.data_table_height =
        parseInt($(window).height()) - $("tbody").offset().top - 80;
    });
    $(".tab-content").css("padding-bottom", "74px");
  }
};
</script>
